import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          width: '100%',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Poppins, sans-serif',
          color: '#303030',
        }}
      >
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin-login" replace state={{ from: location.pathname }} />;
  }

  if (
    allowedRoles &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user.profile_type)
  ) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default ProtectedRoute;

